var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.podeEditar)?_c('div',{staticClass:"editar-publico"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank","title":"Editar Conteúdo"}},[_c('img',{staticClass:"editar-pagina",attrs:{"src":require("../assets/images/icon-editar-exibir.svg")}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }